module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "customer-registrations"
  }, [_c('el-menu', {
    staticClass: "flex items-center px-30 h-60",
    attrs: {
      "mode": "horizontal"
    }
  }, [_c('div', {
    staticClass: "date-picker-right"
  }, [_c('v-custom-date-range-picker', {
    on: {
      "dateRange": function (v) {
        _vm.dateRange = v;
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "p-30"
  }, [_c('el-row', {
    staticClass: "mb-50",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "sm": 24,
      "md": 8
    }
  }, [_c('h3', {
    staticClass: "mb-10"
  }, [_vm._v("Customer Registrations")]), _vm._v(" "), _c('el-card', {
    attrs: {
      "shadow": "none"
    }
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "text-big"
  }, [_vm._v(_vm._s(_vm.statisticsData.customer_registrations_count || 0))]), _vm._v(" "), _c('div', [_vm._v("New customers in selected period")])])])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4f1c0879"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CustomerRegistrations.vue
// module id = 536
// module chunks = 1